import React, { useEffect, useState } from 'react';
interface Snowflake {
  id: number;
  left: number;
  animationDuration: number;
  opacity: number;
  size: number;
  delay: number;
}
export function Snowflakes() {
  const [snowflakes, setSnowflakes] = useState<Snowflake[]>([]);
  useEffect(() => {
    // Generate random snowflakes on mount
    const count = 50;
    const newSnowflakes: Snowflake[] = [];
    for (let i = 0; i < count; i++) {
      newSnowflakes.push({
        id: i,
        left: Math.random() * 100,
        animationDuration: 5 + Math.random() * 10,
        opacity: 0.3 + Math.random() * 0.7,
        size: 4 + Math.random() * 6,
        delay: Math.random() * 5 // 0-5s delay
      });
    }
    setSnowflakes(newSnowflakes);
  }, []);
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true" data-id="element-61">
      {snowflakes.map(flake => <div key={flake.id} className="absolute rounded-full bg-white animate-snowfall" style={{
      left: `${flake.left}%`,
      top: -20,
      width: `${flake.size}px`,
      height: `${flake.size}px`,
      opacity: flake.opacity,
      animationDuration: `${flake.animationDuration}s`,
      animationDelay: `${flake.delay}s`
    }} data-id="element-62" />)}
    </div>;
}